
import { DandDFeatureSource } from "@dndModels/feature_sources/SystemFeatureSource";
import { DataType } from "@dndModels/Types";
import { 
  Feature,
  FeatureBase,
  // Limitation 
} from "@models";

/**
 * Pact Boons are a lot like Feats, 
 * but it's a different set, and in 5e
 * only go to Warlocks.
 */

export class PactBoon extends DandDFeatureSource {
  data_type: DataType = "pact_boon";
  feature_source_type = "PactBoon";
  // features: Feature[];
  class_name_replacement = "";

  constructor(obj?: any) {
    super(obj, "PactBoon");
    if (obj) {
      if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        // const common_util = DataUtilities.getInstance();
        const features: Feature[] = [];
        obj.features.forEach((o: any) => {
          o.source_id = this._id;
          o.source_type = this.feature_source_type;
          const feature = new Feature(o);
          features.push(feature);
        });
        const feature_base = new FeatureBase();
        feature_base.feature_source_id = this._id;
        feature_base.feature_source_type = this.feature_source_type;
        feature_base.features = features;
        this.feature_bases.push(feature_base);
      }
      this.class_name_replacement = obj.class_name_replacement ? obj.class_name_replacement : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     if (this.feature_bases.length === 0 && obj.features && obj.features.length > 0) {
  //       // const common_util = DataUtilities.getInstance();
  //       const features: Feature[] = [];
  //       obj.features.forEach((o: any) => {
  //         o.source_id = this._id;
  //         o.source_type = this.feature_source_type;
  //         const feature = new Feature(o);
  //         features.push(feature);
  //       });
  //       const feature_base = new FeatureBase();
  //       feature_base.feature_source_id = this._id;
  //       feature_base.feature_source_type = this.feature_source_type;
  //       feature_base.features = features;
  //       this.feature_bases.push(feature_base);
  //     }
  //     this.class_name_replacement = obj.class_name_replacement ? obj.class_name_replacement : "";
  //   }
  // }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      class_name_replacement: this.class_name_replacement
    };
  }

  copy(copyMe: PactBoon, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.class_name_replacement = copyMe.class_name_replacement;
  }

  clone(drop_ids = false): PactBoon {
    const new_obj = new PactBoon();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy5e(copyMe: any): void {
    console.log(copyMe);
  }
}